import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { getSvgStyles } from 'baseui/icon';
import { styled } from '../../../theme/utils.js';
import { Icon } from '../icon.js';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const Svg = forwardRef((_a, ref) => {
  var _b = _a, { title, titleId } = _b, props = __objRest(_b, ["title", "titleId"]);
  return jsxs("svg", __spreadProps(__spreadValues({}, props), { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", ref, "aria-labelledby": titleId, children: [title ? jsx("title", { id: titleId, children: title }) : null, jsx("path", { fill: "currentColor", d: "M20.4683 14.9997C20.4683 14.0867 20.1253 12.2957 18.8413 11.3707C18.2963 10.9777 17.3783 10.6147 16.0463 10.9487L18.9043 4.44367L17.0733 3.63867L14.0923 10.4227C13.5113 9.29067 12.3453 8.50667 10.9893 8.50667C9.23128 8.50667 7.78628 9.81367 7.54028 11.5037C7.52328 11.5037 7.50628 11.4987 7.48928 11.4987C5.55928 11.4987 3.98928 13.0687 3.98928 14.9987H1.98828V15.9987C1.98828 19.0657 6.11828 20.3787 7.98828 20.8147V21.9987H15.9883V20.8517C17.8533 20.4047 21.9883 19.0657 21.9883 15.9987V14.9987H20.4683V14.9997ZM17.6723 12.9937C18.2733 13.4267 18.4683 14.5317 18.4683 14.9997H10.9883C10.9883 14.8767 10.9643 14.7607 10.9523 14.6407C12.2143 14.2577 14.3963 13.5857 16.3053 12.9477C17.1963 12.6517 17.5543 12.9077 17.6723 12.9937ZM9.48828 12.0077C9.48828 11.1807 10.1613 10.5077 10.9883 10.5077C11.8153 10.5077 12.4883 11.1807 12.4883 12.0077C12.4883 12.0327 12.4763 12.0547 12.4753 12.0797C11.5623 12.3647 10.7493 12.6127 10.1763 12.7867C9.98128 12.5507 9.76428 12.3367 9.51528 12.1577C9.50928 12.1067 9.48828 12.0607 9.48828 12.0077ZM7.48828 13.4997C8.31528 13.4997 8.98828 14.1727 8.98828 14.9997H5.98828C5.98828 14.1727 6.66128 13.4997 7.48828 13.4997ZM14.8163 19.0567L13.9883 19.2027V20.0007H9.98828V19.1547L9.15328 19.0137C7.84228 18.7927 5.44528 18.0727 4.44528 16.9997H19.5363C18.5383 18.0847 16.1323 18.8257 14.8163 19.0567Z" })] }));
});
const StyledSvg = styled(Svg, getSvgStyles);
const overrides = {
  Svg: {
    component: StyledSvg
  }
};
const IconMeal2 = forwardRef((props, ref) => jsx(Icon, __spreadValues({ ref, overrides }, props)));
IconMeal2.displayName = "IconMeal2";

export { IconMeal2 };
